import React from 'react';
import { Col, Row } from '@paypalcorp/pp-react';
import { GivingZoneTile } from '@paypalcorp/giving-fundraising';
import * as analytics from '../lib/analytics';
import * as logger from './verbose-logger';
const THUMB_IMAGE_IMAGE_ID = 4;
const baseUrl =
  'https://www.paypalobjects.com/paypal-ui/illustrations/focused/svg';
const fundraiserCategories = [
  {
    key: '1001',
    cover: `${baseUrl}/arts-culture.svg`,
  },
  {
    key: '1002',
    cover: `${baseUrl}/education.svg`,
  },
  {
    key: '1003',
    cover: `${baseUrl}/enviroment.svg`,
  },
  {
    key: '1004',
    cover: `${baseUrl}/animal-wildlife.svg`,
  },
  {
    key: '1005',
    cover: `${baseUrl}/health-medicine.svg`,
  },
  {
    key: '1006',
    cover: `${baseUrl}/crime-justice.svg`,
  },
  {
    key: '1007',
    cover: `${baseUrl}/business-employment.svg`,
  },
  {
    key: '1008',
    cover: `${baseUrl}/housing-hunger.svg`,
  },
  {
    key: '1009',
    cover: `${baseUrl}/disaster-relief.svg`,
  },
  {
    key: '1010',
    cover: `${baseUrl}/sports-recreation.svg`,
  },
  {
    key: '1011',
    cover: `${baseUrl}/children-youth.svg`,
  },
  {
    key: '1012',
    cover: `${baseUrl}/human-services.svg`,
  },
  {
    key: '1013',
    cover: `${baseUrl}/international.svg`,
  },
  {
    key: '1014',
    cover: `${baseUrl}/community.svg`,
  },
  {
    key: '1015',
    cover: `${baseUrl}/philanthropy-grants.svg`,
  },
  {
    key: '1016',
    cover: `${baseUrl}/science-research.svg`,
  },
  {
    key: '1017',
    cover: `${baseUrl}/military-veterans.svg`,
  },
  {
    key: '1018',
    cover: `${baseUrl}/faith-spirituality.svg`,
  },
  {
    key: '1019',
    cover: `${baseUrl}/general-support.svg`,
  },
  {
    key: '1020',
    cover: `${baseUrl}/family-support.svg`,
  },
  {
    key: '1021',
    cover: `${baseUrl}/memorial-expenses.svg`,
  },
  {
    key: '1022',
    cover: `${baseUrl}/social-justice.svg`,
  },
];

export function renderItems(campaigns, props) {
  const items = campaigns
    .filter((campaign) => !!campaign)
    .map((campaign, index) => {
      const {
        template_data = '',
        participants = [],
        transaction_summary,
        categories = [],
      } = campaign;

      let templateDataObj = {};
      try {
        templateDataObj = JSON.parse(template_data);
      } catch (e) {
        logger.log('Error: ' + e.message);
      }

      let charityName = '';
      if (participants && participants.length > 0) {
        charityName = participants[0].charity_info
          ? participants[0].charity_info.name
          : '';
      }

      const imageUrl = getCampaignListThumbnailImage(
        templateDataObj.background_image || '',
        categories
      );
      const cardContent = {
        id: campaign.id,
        actions: `[{"params":"campaignId=${campaign.id}"}]`,
        campaignImage: imageUrl,
        charityName: charityName,
        participantText: `${props
          .i18n('label.supporting')
          .replace('{fundraiserName}', '')} ${charityName}`,
        primaryImageUrl: imageUrl,
        campaignTitle: campaign.event_title,

        rangeEndText: `${props
          .i18n('label.of')
          .replace('{currentAmount}', '')
          .replace(' ', '')
          .replace('{targetAmount}', '')} ${campaign.formatedTargetAmount}`,
        rangeStartText: `${campaign.formatedCurrentAmount}`,
        totalAmountText: `${campaign.target_amount}`,
        contributedAmountText: `${transaction_summary.total_amount}`,
        instrumentationData: JSON.stringify([
          {
            item_name: 'dw_giving',
            card_type: 'fundraiser',
            tile_id: campaign.id,
            module: 'fundraiser',
            scope: 'tile',
            link_name: 'donate',
            domain: 'Cause',
            tile_id_type: 'campaign_id',
          },
        ]),
      };

      return <>{renderItemRow(campaign, index, cardContent, props)}</>;
    });

  return items;
}

export function renderItemRow(campaign, index, cardContent, props) {
  let dataFPTI;
  try {
    dataFPTI = JSON.parse(cardContent.instrumentationData);
  } catch (e) {
    dataFPTI = {};
  }

  dataFPTI.account_type =
    props.authState && props.authState === 'ANONYMOUS' ? 'guest' : 'member';

  return (
    <Col xs={12} md={6} lg={4} className='itemCampaign'>
      <div
        onClick={(event) =>
          analytics.onTileClick(event, {
            contentCountry: props.contentCountry,
            authState: analytics.getAccountType(props.authState),
            order: index,
          })
        }
        data-testid={`fundraiserTile-${index}`}
      >
        <GivingZoneTile
          type='fundraiser'
          domain='/'
          isLoading={false}
          openNewTab={props.searchType !== 'npoFundraisers'}
          cardContent={cardContent}
          key={`item-${campaign.id}-${index}`}
          data-fpti={JSON.stringify(dataFPTI)}
        />
      </div>
    </Col>
  );
}

export function getCampaignListThumbnailImage(imageUrl, categories) {
  if (!imageUrl || imageUrl === '') {
    if (categories.length > 0) {
      return getCategoryImage(categories[0]);
    } else {
      return ''; // Specific case scenario where a fundraiser doesn't have a background image configured and neither a category
    }
  } else if (imageUrl.includes('file.')) {
    // backwards compatability for static images
    return imageUrl;
  }
  return imageUrl.replace('image_0', `image_${THUMB_IMAGE_IMAGE_ID}`);
}

export function getCategoryImage(categoryId) {
  const category = fundraiserCategories.find((element) => {
    return element.key === categoryId;
  });

  return category.cover;
}
